import './App.css';
import 'katex/dist/katex.min.css';
import { useState } from 'react';
import AddSubject from './components/AddSubject';
import AddTopic from './components/AddTopic';
import AddSubTopic from './components/AddSubTopic';
import AddNotes from './components/AddNotes';
import AddQuestion from './components/AddQuestions';
import Browse from './components/Browse';
import BrowseQuestions from './components/BrowseQuestions';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from 'react-redux';
import { store } from './globals';
import { ADMIN_KEY_STORAGE } from './helpers/axios';

const TABS = [
  { id: 'subject', label: 'Subject', icon: '📚', step: '01', desc: 'Create a new subject' },
  { id: 'topic', label: 'Topic', icon: '📂', step: '02', desc: 'Add topics to a subject' },
  { id: 'subtopic', label: 'Sub-Topic', icon: '📄', step: '03', desc: 'Add sub-topics' },
  { id: 'notes', label: 'Notes', icon: '📝', step: '04', desc: 'Write notes & facts' },
  { id: 'question', label: 'Question', icon: '❓', step: '05', desc: 'Create quiz questions' },
  { id: 'browse', label: 'Browse', icon: '🔍', step: '——', desc: 'Browse existing content' },
  { id: 'questions', label: 'Questions', icon: '📋', step: '——', desc: 'View & manage questions' },
];

function App() {
  const [activeTab, setActiveTab] = useState('subject');

  const current = TABS.find(t => t.id === activeTab);

  return (
    <Provider store={store}>
      <div className="app-shell">
        {/* Sidebar */}
        <aside className="sidebar">
          <div className="sidebar-brand">
            <h1>Ace It</h1>
            <span>Content Manager</span>
            <button
              type="button"
              onClick={() => {
                localStorage.removeItem(ADMIN_KEY_STORAGE);
                window.location.reload();
              }}
              title="Sign out"
              style={{
                marginTop: 8,
                background: 'transparent',
                border: '1px solid rgba(255,255,255,0.25)',
                color: 'rgba(255,255,255,0.85)',
                fontSize: '0.7rem',
                padding: '4px 10px',
                borderRadius: 6,
                cursor: 'pointer',
              }}
            >
              Sign out
            </button>
          </div>
          <nav className="sidebar-nav">
            <div className="nav-section-label">Content Steps</div>
            {TABS.map(tab => (
              <button
                key={tab.id}
                className={`nav-item${activeTab === tab.id ? ' active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span className="nav-icon">{tab.icon}</span>
                {tab.label}
                <span className="nav-step-badge">{tab.step}</span>
              </button>
            ))}
          </nav>
        </aside>

        {/* Main */}
        <div className="main-content">
          <div className="topbar">
            <div>
              <div className="topbar-breadcrumb">Content Manager &rsaquo; {current.label}</div>
              <h2 className="topbar-title">{current.desc}</h2>
            </div>
          </div>
          <div
            className={`content-area${activeTab === 'browse' || activeTab === 'notes' || activeTab === 'question' || activeTab === 'questions' ? ' content-area--wide' : ''}`}
          >
            {activeTab === 'subject' && <AddSubject />}
            {activeTab === 'topic' && <AddTopic />}
            {activeTab === 'subtopic' && <AddSubTopic />}
            {activeTab === 'notes' && <AddNotes />}
            {activeTab === 'question' && <AddQuestion />}
            {activeTab === 'browse' && <Browse />}
            {activeTab === 'questions' && <BrowseQuestions />}
          </div>
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </Provider>
  );
}

export default App;
